// Gate a route on authentication. While the session is resolving it renders
// `fallback`; once resolved it redirects unauthenticated users to `redirectTo`.
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider.js';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
  fallback?: ReactNode;
}

export function ProtectedRoute({ children, redirectTo = '/login', fallback = null }: ProtectedRouteProps) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'idle' || status === 'loading') return <>{fallback}</>;
  if (status !== 'authenticated') {
    return <Navigate to={redirectTo} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
